import React from 'react';
import { Dashboard } from '@components/common';
import { Skeleton } from '@fourthwall/components';
import { StatGroup } from '@fourthwall/module-analytics';
export const AnalyticsSkeleton = () => (React.createElement("div", null,
    React.createElement("div", { style: { marginBottom: 24 } },
        React.createElement(Skeleton.Shape, { height: 36, width: 260 })),
    React.createElement(Dashboard.Section.ScrollableContent, { hideScrollbar: true, fullWidth: true },
        React.createElement(StatGroup, null,
            React.createElement(Skeleton.Shape, { height: 172, width: "100%" }),
            React.createElement(Skeleton.Shape, { height: 172, width: "100%" }),
            React.createElement(Skeleton.Shape, { height: 172, width: "100%" })))));
